"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const FIRST_PAGE_COUNT = 50;
const NEXT_PAGE_COUNT = 50;
const ListContainer = ({ render, items, firstPage, nextPage, emptyLabel }) => {
    const firstPageCount = firstPage || nextPage || FIRST_PAGE_COUNT;
    const nextPageCount = nextPage || firstPage || NEXT_PAGE_COUNT;
    const [showCount, setShowCount] = (0, react_1.useState)(firstPageCount);
    (0, react_1.useEffect)(() => {
        setShowCount(firstPageCount);
    }, [items]);
    if (items.length === 0 && emptyLabel) {
        return (0, jsx_runtime_1.jsx)("div", { className: 'p-3 text-center', children: emptyLabel });
    }
    const restAddCount = Math.min(items.length - showCount, nextPageCount);
    const slicedItems = items.slice(0, showCount);
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { className: "d-flex flex-column gap-2", children: render(slicedItems) }), showCount < items.length && ((0, jsx_runtime_1.jsx)("div", { className: "d-flex align-items-center justify-content-center p-3", children: (0, jsx_runtime_1.jsxs)("button", { className: "btn btn-outline-dark fw-bold", onClick: () => setShowCount(value => value + restAddCount), children: ["Na\u010D\u00EDst dal\u0161\u00EDch ", restAddCount] }) }))] }));
};
exports.ListContainer = ListContainer;
